/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 */

define(
    [
        'jquery',
        'assets/js/modules/widgets/uploadInfo/uploadInfoWidgetView',
        'assets/js/modules/themes/OvernightPrints/modules/widgets/uploadInfo/uploadInfoView'
    ],
    function($, UploadInfoWidgetView, OnpUploadInfoView) {
        return UploadInfoWidgetView.extend({
            initialize: function(options) {
                UploadInfoWidgetView.prototype.initialize.call(this, arguments);
            },

            renderPreview: function() {
                var _this = this;

                new OnpUploadInfoView({
                    model: _this.createUploadInfoModel(),
                    el: _this.$preview
                });
            }
        });
    }
);
